var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.315 2.18a.76.76 0 0 1 1.37 0l2.368 4.93c.111.23.332.39.586.423l5.45.713c.634.083.887.861.423 1.299L17.528 13.3a.754.754 0 0 0-.225.687l1 5.366a.758.758 0 0 1-1.107.803l-4.835-2.606a.762.762 0 0 0-.722 0l-4.835 2.606a.758.758 0 0 1-1.108-.803l1-5.366a.754.754 0 0 0-.224-.687L2.488 9.545a.755.755 0 0 1 .423-1.299l5.45-.713a.759.759 0 0 0 .586-.423l2.368-4.93Z"
  })));
};
export default SvgStar;